import axios from 'axios';

export const endpointPathMap = {
  quiz: 'quiz.quiz',
  pin: 'infografico-pin.infografico-pin',
  pintexto: 'infog-pin-texto-lateal.infog-pin-texto-lateal',
  acordeon: 'infografico-acordeon.infografico-acordeon',
  slideshow: 'slideshow.slideshow',
  'quiz-moderna': 'quiz-moderna.quiz-moderna',
  'miniclipe-moderna': 'miniclipe-moderna.miniclipe-moderna',
  'galeria-moderna': 'galeria-moderna.galeria-moderna',
  'carrossel-moderna': 'carrossel-moderna.carrossel-moderna',
  'quiz-nextoed': 'quiz-next-oed.quiz-next-oed',
  zoom: 'zoom.zoom',
  'carrossel-nextoed': 'carrossel-nextoed.carrossel-nextoed',
  'carrossel2-moderna': 'carrossel2-moderna.carrossel2-moderna',
  'pintexto-moderna': 'pintexto-moderna.pintexto-moderna',
  'acordeon-moderna': 'acordeon-moderna.acordeon-moderna',
  'pintexto-v2': 'pintexto-v2.pintexto-v2',
  'acordeon-v2': 'acordeon-v2.acordeon-v2',
  'pin-v2': 'pin-v2.pin-v2',
  'pintexto-ftd': 'pintexto-ftd.pintexto-ftd',
  'pin-ftd': 'pin-ftd.pin-ftd',
  'media-transcription': 'media-transcription.media-transcription',
  'media-transcription-nextoed':
    'media-transcription-nextoed.media-transcription-nextoed',
  'pin-moderna-pnld2028': 'pin-moderna-pnld-2028.pin-moderna-pnld-2028',
  'carrossel-moderna-pnld2028':
    'carrossel-moderna-pnld-2028.carrossel-moderna-pnld-2028',
  'acordeon1-moderna-pnld2028':
    'acordeon1-moderna-pnld-2028.acordeon1-moderna-pnld-2028',
  'acordeon2-moderna-pnld2028':
    'acordeon2-moderna-pnld-2028.acordeon2-moderna-pnld-2028',
  'timeline-moderna-pnld2028':
    'linha-do-tempo-moderna-pnld-2028.linha-do-tempo-moderna-pnld-2028',
};

type ContentType = keyof typeof endpointPathMap;

export default async function getOed<T>(
  userToken: string,
  oedType: ContentType,

  oedId: string,
) {
  const response = await axios.get(
    `${process.env.STRAPI_ENDPOINT}/content-manager/collection-types/api::${endpointPathMap[oedType]}/${oedId}`,
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    },
  );

  return { type: oedType, data: response.data as T };
}
